<template>
    <div>
        <div id="header-container" class="px-5 in-step">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white mb-4">
                <h3 class="text-white">{{ $t('Resubmit Withdrawal') }}</h3>
                <span class="fz-16 fw-400">Fill out the form to resubmit withdrawal</span>
            </div>

            <step-container
                :current_step="2"
                :step_list="stepList"
            ></step-container>
        </div>

        <b-container fluid class="pb-5">
            <div id="body-container" class="px-4 pt-3">
                <b-row>
                    <b-col cols="12">
                        <h5 class="mb-4">Resubmit Withdrawal (Same Name)</h5>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Select Currency') }} <span class="text-danger">*</span></label>
                            <select class="form-control" @change="onChangeUserCurrency" v-model="params.senderCurrency">
                                <option value=""></option>
                                <optionUserCurrency
                                v-if="user_currency.length>0"
                                v-for="item in user_currency"
                                :defaultCcy = params.senderCurrency
                                :mapping_currency="mapping_currency"
                                :currency = "item"
                                :userNo = "userNo"
                                :key="item"
                                >
                                </optionUserCurrency>
                            </select>
                            <div v-if="error.senderCurrency" class="invalid-feedback d-block">
                                {{$t(error.senderCurrency)}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Amount') }} <span class="text-danger">*</span></label>
                            <MaskAmount @set-price="changePrice($event)" :bus="withdrawal" ref="withdrawalAmount"></MaskAmount>
                            <div v-if="error.amount" class="invalid-feedback d-block">
                                {{$t(error.amount)}}
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row>
                   
                    <b-col cols="12" md="6">
                        <div class="d-flex align-items-end mb-3">
                            <div class="form-group w-100 mb-0 mr-2">
                                <label>{{ $t('Payment Type') }} <span class="text-danger">*</span></label>
                                <Select2 v-model="params.fixedModel" :options="fixedModelList" @select="onSelectFixedModel($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Payment Type")}' class="form-control"/>
                                <div v-if="error['fixedModel']" class="invalid-feedback d-block mb-3">
                                    {{$t(error['fixedModel'])}}
                                </div>
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Select Fee Currency') }} <span class="text-danger">*</span></label>
                            <select class="form-control" @change="onChangepaymentFeeCcy" v-model="params.paymentFeeCcy">
                                <option value=""></option>
                                <optionUserCurrency
                                v-if="user_currency.length>0"
                                v-for="item in user_currency"
                                :currency = "item"
                                :notzero = true
                                :hidebalance = true
                                :defaultCcy = "params.paymentFeeCcy"
                                :mapping_currency = "mapping_currency"
                                :userNo = "userNo"
                                :key="item"
                                >
                                </optionUserCurrency>
                            </select>
                            <div v-if="error.paymentFeeCcy" class="invalid-feedback d-block">
                                {{$t(error.paymentFeeCcy)}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Purpose of Payment') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.paymentPurpose" :options="paymentPurposeOpt" @select="onSelectPurpose($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Select purpose")}' class="form-control"/>
                            <div v-if="error['paymentPurpose']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentPurpose'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <div class="d-flex align-items-center">
                                <label for="paymentFee" class="mb-0 text-nowrap">{{ $t('Payment Fee') }}</label>
                            <input type="text" readonly class="form-control-plaintext text-danger px-2" id="paymentFee" :value="params.paymentFee?params.paymentFee+' USD':'-'">
                            </div>
                            <div v-if="error['paymentFee']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentFee'])}}
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mb-4">
                    

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Bank charges to be borne') }} <span class="text-danger">*</span></label>
                            <Select2 v-model="params.costBorne" :options="costBorneOpt" @select="onSelectCostBorne($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Bank charges to be borne")}' class="form-control"/>
                            <div v-if="error['costBorne']" class="invalid-feedback d-block mb-3">
                                {{$t(error['costBorne'])}}
                            </div>
                        </div>
                    </b-col>

                    <b-col cols="12" md="6">
                        <div class="form-group mb-3">
                            <label>{{ $t('Remarks') }}</label>
                            <input type="text" v-model="params.paymentReference" class="form-control" :placeholder="$t('Payment Reference')"/>
                            <div v-if="error['paymentReference']" class="invalid-feedback d-block mb-3">
                                {{$t(error['paymentReference'])}}
                            </div>
                        </div>
                    </b-col>
                    
                </b-row>
                <b-row class="mb-5">
                    <b-col cols="12" class="d-flex">
                        <button @click="$router.go(-1);" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                        <button @click="doSubmit" class="btn btn-primary d-block">{{ $t('Next') }}</button>
                    </b-col>
                </b-row>
                
            </div>
        </b-container>
        <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
</template>
<script>

import LoaderComponent from "@/components/LoaderComponent";
import Select2 from 'v-select2-component';
import CreateAccount from "@/services/CreateAccount";
import Withdrawal from "@/services/Withdrawal";
import MaskAmount from "@/components/Mask/MaskAmount";
import optionUserCurrency from '@/components/optionUserCurrency';
import stepContainer from "@/components/CardManagement/stepContainer";

import Vue from "vue";

const FIXED_MODEL = {
                1:"Foreign Exchange Account",
                2:"Receiving Account"
            };

const PAYMENT_PURPOSE = {
                1:"current settlement",
                2:"loan",
                3:"travel expenses",
                4:"living expenses",
                5:"investment funds",
                6:"office expenses",
                7:"engineering funds",
                8:"labor costs/salaries",
                9:"tuition fees",
                10:"others"
            };

const COST_BORNE = {
                "OUR":"OUR (sender pays all charges)",
                "SHA":"SHA (shared charges)"
            };

            const FEE = {
    "SWIFT":{
        "SHA":25,
        "OUR":55
    },
    "LOCAL":{
        "AUS":4,
        "JPN":10,
        "IDN":4,
        "CAN":7,
        "FIN":4,
        "FRA":4,
        "DEU":4,
        "SGP":4,
        "ESP":4,
        "SWE":4,
        "SWZ":4,
        "GBR":4,
        "MYS":4,
        "VNM":4,
        "USA":4,
        "THA":4,
        "PHL":4,
        "HKG":5,
        "PRK":5,
        "KOR":5,
        "CRI":10,
        "ECU":10,
        "LKA":10,
        "IND":30,
        "NZL":7,
        "POL":4,
        "LUX":4,
        "KHM":10
    }
}


export default {
   name: 'update-withdrawal',
   data() {
       return {
            publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
            user_currency:[],
            benificiaryList:[],
            mapping_currency:{},
            stepList:["Update Beneficiary","Update Withdrawal", "Summary"],
            userNo:'',
            isLoading:false,
            withdrawal:new Vue(),
            selectedAccountName:'',
            selectedCardNo:'',
            payeeCcy:'',
            fixedModelList:[],
            paymentPurposeOpt:[],
            costBorneOpt:[],
            mappingFee:FEE,
            payeeCountry:'',
            optional:['paymentReference'],
            params:{
                paymentFee:'',
                senderCurrency:'',
                paymentFeeCcy:'',
                amount:'',
                fixedModel:'',
                benificiaryId:'',
                paymentPurpose:'',
                paymentReference:'',
                costBorne:''
            },
            error:{
                paymentFee:'',
                senderCurrency:'',
                paymentFeeCcy:'',
                amount:'',
                benificiaryId:'',
                paymentPurpose:'',
                paymentReference:'',
                fixedModel:'',
                filtercostBorne:''
            }
       }
   },
   components: {
       LoaderComponent,
       Select2,
       optionUserCurrency,
       MaskAmount,
       stepContainer
   },
   methods:{
    setFee(){
        this.params.paymentFee = '';
        // if(this.payeeCountry){
        //     const fee = this.mappingFee['LOCAL'][this.payeeCountry];
        //     this.params.paymentFee = fee?fee:4;
        // }
        if(this.params.costBorne){
            this.params.paymentFee = this.mappingFee['SWIFT'][this.params.costBorne];
        }
    },
    gotoAddBeneficiary(){
        localStorage.removeItem('add_beneficiary');
        this.$router.push({ 
            path: 'add-beneficiary'
        });
    },
    onSelectCostBorne(){
        this.error.costBorne = '';
        this.setFee();
    },
    onSelectPurpose(){
        this.error.paymentPurpose = '';
    },
    onSelectFixedModel(){
        this.error.fixedModel = '';
    },
    onChangeUserCurrency(){
        this.error.senderCurrency='';
    },
    changePrice(event){
        this.error.amount = '';
        this.params.amount = event;
    },
    doEscapeMarkup(markup){
        return markup;
    },
    getUser(){
        let self = this;
        CreateAccount.list().then((response)=>{
            if (response.status == 200) {
                let account = response.data.data;
                if(account){
                    account.forEach(element => {
                        if(element.status == 2){
                            self.userNo = element.userNo;
                            self.getSubAccount();
                        }
                    });
                }
            }
        });
    },
    getSubAccount(){
        let self = this;
        CreateAccount.listSubAccount({
                start:0,
                length:-1,
                search:{value:self.userNo}
            }).then((response)=>{
                if (response.status == 200) {
                    if(response.data.data.length>0){
                        self.sub_account = response.data.data[0];
                        self.user_currency = this.sub_account['currency'].split(",");
                    }
                }
            });
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            if(!self.params[key]&& !self.optional.includes(key)){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    doSubmit(){
        let self = this;
        if(this.validate()){
            let payeeAmount = this.params.amount;
            let paymentAmount = this.params.amount;

            if(this.params.fixedModel == 1){
                payeeAmount = 0;
            }
            else{
                paymentAmount = 0;
            }

            const update_withdrawal = {
                benificiaryId:this.params.benificiaryId,
                fixedModel:parseInt(this.params.fixedModel),
                paymentCcy:this.params.senderCurrency,
                paymentAmount:paymentAmount,
                payeeAmount:payeeAmount,
                payeeCcy:this.payeeCcy,
                paymentPurpose:parseInt(this.params.paymentPurpose),
                paymentReference:this.params.paymentReference,
                costBorne:this.params.costBorne,
                paymentFeeCcy:this.params.paymentFeeCcy,
                paymentFee:this.params.paymentFee,
                accountName:this.selectedAccountName,
                cardNo:this.selectedCardNo
            };

            localStorage.setItem('update_withdrawal', JSON.stringify(update_withdrawal));
            
            this.$router.push({ 
                path: 'resubmit-withdrawal-summary',
                query: { "id":self.$route.query['id'] }
            });
        }
    },
    onChangepaymentFeeCcy(){
        this.error.paymentFeeCcy = '';
    },
    getMessage: function (key) {
        return this.$t(key)
    },
    checkError(err){
        this.isLoading = false;
        const response = err.response;  
        console.log("===================");
        let self = this;
        if(response.status == 400){
            console.log(response.data);
            if(typeof response.data.message === 'string'){
                this.$swal({
                    icon: 'info',
                    html:response.data.message,
                    showConfirmButton: true,
                    confirmButtonText: self.getMessage('OK')
                });
            }
            else{
                if(response.data.message['errorMsg']){
                    this.$swal({
                        icon: 'info',
                        html:response.data.message['errorMsg'],
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
                else{
                    let ret = [];
                    Object.keys(response.data.message).forEach((key) => {
                        ret.push(response.data.message[key][0]);
                    });

                    this.$swal({
                        icon: 'info',
                        html:ret.join("<br>"),
                        showConfirmButton: true,
                        confirmButtonText: self.getMessage('OK')
                    });
                }
            }
        }      
        else if(response.status == 401 && response.data.name == "Unauthorized"){
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({ 
                    path: '/login', 
                });
        }
        else{
            if(localStorage.getItem("token")){
                var msg = (response.data)?response.data.message:err.message;
                this.$notify({
                    type: 'warn',
                    text: msg
                })
            }
        }
    }
   },
   mounted(){
    let self = this;
        this.$nextTick(() => {
            
            this.fixedModelList = [];
            Object.keys(FIXED_MODEL).forEach(key => {
                this.fixedModelList.push({"id":key,"text":FIXED_MODEL[key]});
            });

            this.paymentPurposeOpt = [];
            Object.keys(PAYMENT_PURPOSE).forEach(key => {
                this.paymentPurposeOpt.push({"id":key,"text":PAYMENT_PURPOSE[key]});
            });

            this.costBorneOpt = [];
            Object.keys(COST_BORNE).forEach(key => {
                this.costBorneOpt.push({"id":key,"text":COST_BORNE[key]});
            });

            CreateAccount.listCurrency().then((response)=>{
                self.mapping_currency = response.data;
                self.getUser();
                let update_withdrawal = localStorage.getItem("update_withdrawal");
                if(update_withdrawal){
                    update_withdrawal = JSON.parse(update_withdrawal);
                    Object.keys(this.params).forEach(key => {
                        self.params[key] = update_withdrawal[key];
                    });
                    
                    this.params.amount = (this.params.fixedModel == 1)?update_withdrawal["paymentAmount"]:update_withdrawal["payeeAmount"];
                    this.$refs["withdrawalAmount"].init(this.params.amount);
                    
                    this.params.senderCurrency = update_withdrawal.paymentCcy;
                    this.setFee();
                }
                else if(this.$route.query['id']){
                    Withdrawal.withdrawalList({id:this.$route.query['id']}).then((response)=>{
                        let data = response.data;
                        if(data.length>0){
                            data = data[0];
                            Object.keys(self.params).forEach(key => {
                                if(data[key]){
                                    self.params[key] = data[key];
                                }
                            });

                            this.params.amount = (this.params.fixedModel == 1)?data["paymentAmount"]:data["payeeAmount"];
                            this.$refs["withdrawalAmount"].init(this.params.amount);
                            
                            this.params.senderCurrency = data.paymentCcy;
                            this.setFee();
                        }
                    });
                }

                let beneficiary = localStorage.getItem("update_beneficiary");
                beneficiary = JSON.parse(beneficiary);
                
                this.selectedAccountName = beneficiary['accountName'];
                this.selectedCardNo = beneficiary['cardNo'];
                this.payeeCcy = beneficiary['accountCcy'];
                this.payeeCountry = beneficiary['countryCode'];
            });
        });
   }
};
</script>

<style>
input#paymentFee{
    border: unset !important;
}
</style>
